<nav id="sidebar" class="active">
    <span class="logo">
    </span>
    <ul class="list-unstyled components mb-5">
      <li [routerLinkActive]="['active']" *ngxPermissionsOnly="['evaluacionWeb']">
        <a [routerLink]="['/gestiones']">
          <img height="30" src="../../../assets/images/navbar/calendar.png">
        </a>
      </li>
      <li *ngIf="canLogout" style="position:fixed;bottom: 0;min-height: 55px;display: block;min-width: 75px;max-width: 75px;">
      <a (click)="showPregunta()"><img height="30" src="../../../assets/images/navbar/logout.png"></a>
    </li>
    </ul>
</nav>
